import { __awaiter, __decorate } from "tslib";
import { Component, ViewEncapsulation } from '@angular/core';
import { SharedHttp } from '../../services/http-client.service';
import { WebsiteThemeService } from '../../services/website-theme.service';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { LanguageService } from '../../services/language.service';
import { GoToPageService } from "../../services/go-to-page.service";
import { GoogleAnalyticsService } from "../../services/google-analytics.service";
/**
 * KYC Questionnaire Component
 */
let KycQuestionnaireComponent = class KycQuestionnaireComponent {
    constructor(httpClient, sanitizer, themeService, router, languageService, goToService, googleAnalyticsService) {
        this.httpClient = httpClient;
        this.sanitizer = sanitizer;
        this.themeService = themeService;
        this.router = router;
        this.languageService = languageService;
        this.goToService = goToService;
        this.googleAnalyticsService = googleAnalyticsService;
        this.questionnaire = [];
        this.questions = [];
        this.backColor = '';
        this.accentColor = '';
        this.mainColor = '';
        this.borderRadiusLarger = '';
        this.borderRadiusSmaller = '';
        this.textColor = '';
        this.errorColor = '';
        this.secondaryColor = '';
        this.successColor = '';
        this.linkColor = '';
        this.inputBackColor = '';
        this.errorMessage = "";
        this.sentEmailMessage = false;
        this.confirmationMessage = '';
        this.confirmationMessageError = '';
        this.provision = JSON.parse(localStorage.getItem('provision'));
        this.checkedAnswers = [];
        this.otherAnswers = [];
        this.orderData = JSON.parse(localStorage.getItem('orderData'));
        this.orderType = localStorage.getItem('orderType');
        this.riskLevel = localStorage.getItem('riskLevel');
        this.questionnaireSubmitted = localStorage.getItem("questionnaireSubmitted");
        this.lang = localStorage.getItem('language') ? localStorage.getItem('language') : 'en';
        this.professions = [];
        this.placeholderTextProfessions = '';
        this.keywordname = 'name';
        this.data = {};
        this.professionError = false;
        this.documentsError = false;
        this.dropdownProfessionInFocus = false;
        this.allEmploymentTypes = [];
        this.placeholderText = '';
        this.employmentTypeError = false;
        this.dropdownEmploymentTypeInFocus = false;
        this.selectedFiles = [];
        this.filesToUpload = [];
        this.fileSize = 2;
        this.user = JSON.parse(localStorage.getItem('user'));
        this.themeService.getTheme().subscribe((data) => {
            this.backColor = this.themeService.getStyleAttribute('side_menu');
            this.accentColor = this.themeService.getStyleAttribute('accent_color');
            this.mainColor = this.themeService.getStyleAttribute('main_color');
            this.borderRadiusLarger = this.themeService.getStyleAttribute('border_radius_larger');
            this.textColor = this.themeService.getStyleAttribute('text_color');
            this.successColor = this.themeService.getStyleAttribute('success_color');
            this.errorColor = this.themeService.getStyleAttribute('error_color');
            this.linkColor = this.themeService.getStyleAttribute('link_color');
            this.inputBackColor = this.themeService.getStyleAttribute('input_background_color');
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
        });
        this.httpClient.get('user/kycquestionnaire?language_name=' + this.lang).subscribe((data) => {
            this.questionnaire = data[0];
            this.questions = this.questionnaire[0].questions;
        });
    }
    ngOnInit() {
        if (this.user == null || this.user == undefined) {
            this.router.navigateByUrl('/login');
        }
        if (this.user.user_settings.check_status_verbose_id != 'KYC_RESIDENT_CHECK_FAILD') {
            this.router.navigateByUrl('/');
        }
        this.languageService.language.subscribe((language) => {
            this.lang = language;
            this.httpClient.get('user/kycquestionnaire?language_name=' + this.lang).subscribe((data) => {
                this.questionnaire = data[0];
                this.questions = this.questionnaire[0].questions;
            });
        });
        this.getProfessions();
        this.getEmploymentTypes();
    }
    sendQuestionnaire() {
        this.employmentTypeError = false;
        this.professionError = false;
        this.documentsError = false;
        this.errorMessage = '';
        if (Object.keys(this.checkedAnswers).length == 0) {
            this.errorMessage = 'KYC_QUSTIONNARIE.QUESTION_ERROR';
            return;
        }
        this.checkEmploymentType();
        this.checkProfession();
        if (this.selectedFiles.length == 0) {
            this.documentsError = true;
        }
        if (this.employmentTypeError || this.professionError || this.documentsError) {
            return;
        }
        let questionIds = [];
        let answers = Array();
        for (let i = 0; i < this.questions.length; i++) {
            questionIds[i] = this.questions[i].id;
        }
        for (let i = 0; i < questionIds.length; i++) {
            let allFalse = true;
            let optionsAnswers = Array();
            for (const key in this.checkedAnswers) {
                if (this.checkedAnswers[key] && Number(key.split('.')[0]) == questionIds[i]) {
                    allFalse = false;
                    for (let j = 0; j < this.questions[i].question_options.length; j++) {
                        if (this.questions[i].question_options[j].id == Number(key.split('.')[1]) && this.questions[i].question_options[j].customizable) {
                            if (this.otherAnswers[key] === undefined || this.otherAnswers[key] === "") {
                                this.errorMessage = 'QUESTIONNAIRE.TEXTAREA_ERROR';
                                return;
                            }
                            else if (this.otherAnswers[key].length > 254) {
                                this.errorMessage = 'QUESTIONNAIRE.TEXTAREA_LENGTH';
                                return;
                            }
                        }
                    }
                    const temp = {
                        'question_option_id': Number(key.split('.')[1]),
                        'customizable_value': this.otherAnswers[key] !== undefined ? this.otherAnswers[key] : null
                    };
                    optionsAnswers.push(temp);
                }
            }
            if (allFalse) {
                this.errorMessage = 'QUESTIONNAIRE.ANSWER_ERROR';
                return;
            }
            const temp = {
                'question_id': questionIds[i],
                'options_answers': optionsAnswers
            };
            answers.push(temp);
        }
        let result = {
            'questionnaire_id': this.questionnaire[0].id,
            'answers': answers,
            'user_data': this.data,
            'language_name': this.lang
        };
        this.httpClient.post('user/savequestionnaire', result).subscribe((submissionData) => {
            localStorage.setItem("questionnaireSubmitted", "true");
            this.submitDocuments();
        });
    }
    getProfessions() {
        var language = localStorage.getItem('language');
        if (language == null) {
            language = this.lang;
        }
        this.httpClient.get('user/professions').subscribe((data) => {
            this.professions = data;
            this.professions = this.professions.filter(profession => profession.lang === language);
        }, (error) => {
        });
    }
    getEmploymentTypes() {
        var language = localStorage.getItem('language');
        if (language == null) {
            language = this.lang;
        }
        this.httpClient.get('user/employmenttypes').subscribe((data) => {
            this.allEmploymentTypes = data;
            this.allEmploymentTypes = this.allEmploymentTypes.filter(profession => profession.lang === language);
        }, (error) => {
        });
    }
    setProfession(item) {
        this.data.professionId = item.id;
        this.checkProfession();
    }
    checkProfession() {
        if (this.data.professionId == "null" || this.data.professionId === undefined) {
            this.professionError = true;
        }
        else {
            this.professionError = false;
        }
    }
    onChangeSearchProfession(val) {
    }
    onProfessionClear(e) {
        this.data.professionId = "null";
    }
    onFocusedProfession(e) {
        this.dropdownProfessionInFocus = e;
    }
    setEmploymentType(item) {
        this.data.employmentTypeId = item.id;
        this.checkEmploymentType();
    }
    checkEmploymentType() {
        if (this.data.employmentTypeId == "null" || this.data.employmentTypeId === undefined) {
            this.employmentTypeError = true;
        }
        else {
            this.employmentTypeError = false;
        }
    }
    onChangeSearchEmploymentType(val) {
    }
    onEmploymentTypeClear(e) {
        this.data.employmentTypeId = "null";
    }
    onFocusedEmploymentType(e) {
        this.dropdownEmploymentTypeInFocus = e;
    }
    fileChange(event) {
        this.filesToUpload = this.toArray(event.target.files);
        if (this.selectedFiles.length == 0) {
            this.selectedFiles = this.filesToUpload;
        }
        else {
            for (let i = 0; i < this.filesToUpload.length; i++) {
                for (let j = 0; j < this.selectedFiles.length; j++) {
                    if (this.filesToUpload[i].name === this.selectedFiles[j].name) {
                        break;
                    }
                    if (j === this.selectedFiles.length - 1) {
                        this.selectedFiles = this.selectedFiles.concat(this.filesToUpload[i]);
                    }
                }
            }
        }
        document.getElementById('my-file').value = '';
        this.validateFiles();
    }
    toArray(fileList) {
        return Array.prototype.slice.call(fileList);
    }
    validateFiles() {
        for (let i = 0; i < this.selectedFiles.length; i++) {
            let fileExtension = this.selectedFiles[i].name.split('.').pop();
            let allowed = this.checkFileExtension(fileExtension);
            if (this.selectedFiles[i].size > 1024 * 1024 * this.fileSize || !allowed) {
                this.fileError = true;
                return;
            }
        }
        this.fileError = false;
    }
    checkFileExtension(fileExtension) {
        let allowedExtensions = ['jpg', 'png', 'jpeg', 'pdf', 'gif', 'JPG', 'JPEG', 'PNG', 'PDF', 'GIF'];
        let allowed = allowedExtensions.includes(fileExtension);
        return allowed;
    }
    removeFile(index) {
        this.selectedFiles.splice(index, 1);
        this.validateFiles();
    }
    roundNumber(num, places) {
        return Math.round(num * Math.pow(10, places)) / Math.pow(10, places);
    }
    submitDocuments() {
        return __awaiter(this, void 0, void 0, function* () {
            let formData = new FormData();
            const files = this.selectedFiles;
            for (let i = 0; i < files.length; i++) {
                formData.append(files[i].name, files[i]);
            }
            let documentationFiles = [];
            const readUploadedFileAsDataURL = (file) => {
                const temporaryFileReader = new FileReader();
                return new Promise((resolve) => {
                    temporaryFileReader.onload = () => {
                        resolve(temporaryFileReader.result);
                        const tempFile = {
                            name: file.name,
                            content: temporaryFileReader.result
                        };
                        documentationFiles.push(tempFile);
                    };
                    temporaryFileReader.readAsDataURL(file);
                });
            };
            for (let i = 0; i < files.length; i++) {
                yield readUploadedFileAsDataURL(files[i]);
            }
            this.httpClient.post('user/useradditionaldocumentation', { user_id: 1, documentation_files: documentationFiles }).subscribe((success) => {
                this.router.navigateByUrl('pending');
            });
        });
    }
};
KycQuestionnaireComponent.ctorParameters = () => [
    { type: SharedHttp },
    { type: DomSanitizer },
    { type: WebsiteThemeService },
    { type: Router },
    { type: LanguageService },
    { type: GoToPageService },
    { type: GoogleAnalyticsService }
];
KycQuestionnaireComponent = __decorate([
    Component({
        selector: 'ecd-kyc-questionnaire',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./kyc-questionnaire-component.html")).default
    })
], KycQuestionnaireComponent);
export { KycQuestionnaireComponent };
